import styled from 'styled-components'

export const Wrapper = styled.div`
  > div + div {
    margin-top: 24px;
  }
`

export const Section = styled.div`
  padding: 24px;
  border-radius: 16px;
  background: #ffffff;
  border: 1px solid #f5f5f5;
  box-shadow: 0px 4px 8px 0px #00000014;
`

export const Title = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #213f68;
`

export const Description = styled.div`
  color: #363636;
  margin-top: 16px;
`

export const Alert = styled.div`
  border: 1px solid #b6dbfb;
  background-color: #e7f3fe;
  padding: 8px;
  margin-top: 24px;
  border-radius: 8px;
  font-size: 14px;
  color: #363636;
  display: flex;
  gap: 8px;
  svg {
    margin: 4px 4px 0;
    color: #213f68;
  }
`
